import { render, staticRenderFns } from "./EditAnswer.vue?vue&type=template&id=289c3adb&"
import script from "./EditAnswer.vue?vue&type=script&lang=js&"
export * from "./EditAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports